import React, { PropTypes } from 'react';
import { hashHistory, Link } from 'react-router'
import { inject, observer } from "mobx-react";
import { observable, toJS } from 'mobx';

// import booleanPointInPolygon from '@turf/boolean-point-in-polygon';
// import { polygon, point } from '@turf/helpers';

import LeafletMap from "../LeafletMap";
// import Spinner from "../Spinner";
import { getCenter } from "./getCenterLatLng";
// import Form, { SelectInput, TextInput } from "../Form";
import parameterTypeParser from "../../libs/parameterTypeParser";
import { getDisplayDate } from "../../libs/date";
// import FormMultiSelectInput from '../FormMultiSelectInput';

import { preference, token } from "../../libs/localStorage";
import MapFilterGroup from './MapFilterGroup';
import moment from 'moment';
import { ADMINISTRATIVE_DIVISIONS } from '../../config';

const leafletURL = "https://api.mapbox.com/styles/v1/mapbox/streets-v10/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1Ijoic3VoZWwxODIiLCJhIjoiY2l0eHp2ZmYxMDNzZjJvbnZkNGd1dnF6NiJ9.et72vhvEX00iI2aCWnAiaA";

@inject('stationStore', 'tagStore', 'mapStore', 'parameterStore', 'stationTypeStore', 'folderStore')
@observer
export default class IndexLeaflet extends React.Component {

  static contextTypes = {
    notify: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired
  };

  state = {
    districts: [],
    basins: [],
    provinces: [],
  };

  map;
  dispose;
  @observable markers = [];
  @observable multiTagOptions = [];
  @observable statusDays = 1;

  @observable filteredStations = null;
  @observable selectedBoundaryFeature = null;

  componentWillMount() {
    const { mapStore, tagStore, parameterStore, stationTypeStore } = this.props;

    if (!parameterStore.items.length && !parameterStore.isLoading) parameterStore.fetchItems();
    if (!tagStore.items.length && !tagStore.isLoading) tagStore.fetchItems();
    if (!stationTypeStore.items.length && !stationTypeStore.isLoading) stationTypeStore.fetchItems();

    this.populateTagOptions();

    if (mapStore.stations.length === 0 && !mapStore.loadingMarkers) {
      mapStore.fetchMapMarkers().catch(err => {
        console.log(err);
        this.context.notify.error({ message: 'failed to fetch map markers' })
      })
    }

    setTimeout(() => {

      ADMINISTRATIVE_DIVISIONS.forEach(item => {
        fetch(item.file).then(res => res.json()).then(res => this.setState({ [item.name]: res }));
      })

      // fetch('geojson/bd_district.json').then(res => res.json()).then(districts => this.setState({ districts }));
      // fetch('geojson/basin.json').then(res => res.json()).then(basins => this.setState({ basins }));
      // fetch('geojson/bd_province.json').then(res => res.json()).then(provinces => this.setState({ provinces }));
    }, 0);
  }

  populateTagOptions = () => {
    const { tagStore, mapStore } = this.props;

    if (tagStore.items.length === 0) {
      setTimeout(() => {
        this.populateTagOptions();
      }, 300)
    } else {
      let previousTags = localStorage.getItem(token.getDecoded().id);

      if (previousTags) {
        previousTags = JSON.parse(previousTags);

        this.multiTagOptions = tagStore.items.map(item => {
          const previouslySelected = previousTags.find(i => i === item.name);

          return ({
            id: item.id,
            name: item.name,
            label: item.name,
            value: !!previouslySelected
          })
        });

        mapStore.onChangeSearchTags(this.multiTagOptions.filter(item => !!item.value).map(item => item.name));
      } else {
        this.multiTagOptions = tagStore.items.map(item => ({
          id: item.id,
          name: item.name,
          label: item.name,
          value: true
        }));
        mapStore.onChangeSearchTags(this.multiTagOptions.filter(item => !!item.value).map(item => item.name));
      }
    }
  }

  getPopupBox = marker => {
    if (!marker) return <div />;
    const { parameterStore } = this.props;
    return (
      <div id={'station_marker-' + marker.id + '-popup'} style={{ maxHeight: '300px' }}>
        <div style={{ fontSize: '15px', fontWeight: 'bold', color: '#006effab' }}>
          <Link to={`/station/${marker.id}`}>{marker.name}</Link>
        </div>
        <span className="fa fa-close" style={{ position: 'absolute', right: 2, top: 2 }} onClick={() => this.props.mapStore.selectedMarker = null} />
        {!!marker.tags && marker.tags.length > 0 ? (
          <small>
            <em>
              Tags: {marker.tags && marker.tags.length && marker.tags.map(tag => tag.name).join(', ')}
            </em>
          </small>
        ) : ''}

        {(marker.max_station_time || marker.max_station_timestamp || marker.parameters) ?
          <div className="column-it" style={{ padding: '10px', maxHeight: '200px', overflowY: 'scroll' }}>
            {marker.max_station_time ? (
              <div className="popup-table-item">
                <strong>Time</strong>
                {/*<div>{new Date(marker.max_station_time).toLocaleString()}</div>*/}
                <div>{getDisplayDate(marker.max_station_time, { format: 'DD/MM/YYYY, HH:mm:ss' })}</div>
              </div>
            ) : ''}
            {marker.max_station_timestamp ? (
              <div className="popup-table-item">
                <strong>Timestamp</strong>
                {/*<div>{new Date(marker.max_station_timestamp).toLocaleString()}</div>*/}
                <div>{getDisplayDate(marker.max_station_timestamp, { format: 'DD/MM/YYYY, HH:mm:ss' })}</div>
              </div>
            ) : ''}
            {marker.parameters && marker.parameters.length > 0 ? marker.parameters.filter(param => param.value !== null).map((param, index) => {
              let parameter = parameterStore.findById(param.parameter_id);
              return (
                <div key={`${marker.name}--${param.series_name}_${index}`} className="popup-table-item">
                  <strong>
                    {param.series_name}:
                  </strong>
                  <div>
                    {parameterTypeParser(param.value, parameter ? parameter.property : '')} {param.symbol}
                  </div>
                </div>
              );
            }) : ''}
          </div> : ''}
      </div>
    );
  };

  onMarkerClick = marker => {
    let stationId = marker.id.split('-')[1];
    const station_redirect = preference.get().station_redirect;
    hashHistory.push(`/station/${stationId}/${station_redirect || 'monitoring'}`);
  };

  onTagSelect = (item, onChangeSearchTags) => {
    item.value = !item.value;
    onChangeSearchTags(this.multiTagOptions.filter(item => !!item.value).map(item => item.name))
  }

  render() {
    const { tagStore, stationTypeStore, stationStore, folderStore } = this.props;
    let { stations, loadingMarkers, filteredStations, searchTag, stationStatus, onChangeSearchTags, onChangeStationStatus, selectedMarker, onMarkerOver } = this.props.mapStore;
    const common_station_search = preference.get().common_station_search;
    const _filteredStations = this.filteredStations || [];
    // const markers = (this.filteredStations || []).map(station => {
    const markers = (!!common_station_search ? stationStore.filterStations(_filteredStations, folderStore.searchFilter) : _filteredStations).map(station => {
      let color = station.color;
      // let color = station.color === 'YELLOW' ? 'YELLOW' :
      //   moment(station.max_station_timestamp).valueOf() > moment().subtract(this.statusDays, 'days').valueOf() ? 'GREEN' : 'RED';

      let svgIcon = `<svg id="${'ticket_marker-' + station.id}" viewBox="0 0 10 10" x="5" width="10" style="margin-left: -1px; margin-top: -2px; fill:${color}">
                       <circle cx="5" cy="5" r="4" stroke="black" stroke-width="0.5px" />
                     </svg>`;

      if (station.station_type_id) {
        let stationType = stationTypeStore.items.find(item => item.id === station.station_type_id);
        if (!!stationType && !!stationType.icon) svgIcon = stationType.icon.replace('svg', `svg class="marker-svg-icon" style="fill:${color};" id="${'ticket_marker-' + station.id}"`);
      }

      return Object.assign({}, {
        position: [station.latitude, station.longitude],
        id: `station_marker-${station.id}`,
        color: color,
        icon: svgIcon,
        // popupBox: this.getPopupBox(station)
      });
    });

    const mapCenter = getCenter(this.filteredStations || filteredStations);

    const calcPercent = type => {
      if (!this.filteredStations || this.filteredStations.length === 0) return ' - ';
      let count = this.filteredStations.filter(item => item.color === type).length;
      return {
        count, percent: Math.round(10000 * count / this.filteredStations.length) / 100 + '%'
      };
    };
    const status = {
      green: calcPercent('GREEN'),
      red: calcPercent('RED'),
      yellow: calcPercent('YELLOW')
    };

    let popupUpMarker = !!selectedMarker && (this.filteredStations || filteredStations).find(item => +item.id === +selectedMarker);

    return (
      <div>
        <div className='index-map-filter-container space-between' style={{ alignItems: 'center', marginBottom: '16px' }}>
          <MapFilterGroup
            statusProps={{ statusDays: this.statusDays, onChangeStatusDays: e => this.statusDays = e.target.value }}
            tagsProps={{ tags: tagStore.items, isLoading: tagStore.isLoading }}
            divisionProps={{
              options: [
                { label: 'All', value: 'all' },
                ...ADMINISTRATIVE_DIVISIONS.map(item => ({
                  label: item.label,
                  value: item.name,
                  geoJson: this.state[item.name],
                  key: item.key
                }))
                // { label: 'Province', value: 'province', geoJson: this.state.provinces, key: 'Name' },
                // { label: 'District', value: 'district', geoJson: this.state.districts, key: 'DIST_NAME' },
                // { label: 'Basin', value: 'basin', geoJson: this.state.basins, key: 'BASIN_NAME' },
              ],
            }}
            stationProps={{
              stations: this.props.mapStore.stationsJson,
              setFilteredStations: stations => this.filteredStations = stations,
              setSelectedBoundary: selectedBoundaryFeature => this.selectedBoundaryFeature = selectedBoundaryFeature
            }}
          />
          <div className='bordered station-status-table'>
            <div className='DataTable'>
              <table>
                <tbody>
                  <tr>
                    <td width='20'><i className='fa fa-circle' style={{ color: 'green' }} /></td>
                    <th width="100">Normal</th>
                    <td width="30" style={{ textAlign: 'center' }}>{status.green.count}</td>
                    <td width="50" style={{ textAlign: 'center' }}>{status.green.percent}</td>
                  </tr>
                  <tr>
                    <td width='20'><i className='fa fa-circle' style={{ color: 'yellow' }} /></td>
                    <th width="100">QC Error</th>
                    <td width="30" style={{ textAlign: 'center' }}>{status.yellow.count}</td>
                    <td width="50" style={{ textAlign: 'center' }}>{status.yellow.percent}</td>
                  </tr>
                  <tr>
                    <td width='20'><i className='fa fa-circle' style={{ color: 'red' }} /></td>
                    <th width="100">No Communication</th>
                    <td width="30" style={{ textAlign: 'center' }}>{status.red.count}</td>
                    <td width="50" style={{ textAlign: 'center' }}>{status.red.percent}</td>
                  </tr>
                  <tr>
                    <td width='20'>{ }</td>
                    <td width="100">{ }</td>
                    <th width="30" style={{ textAlign: 'center' }}>{!!this.filteredStations && this.filteredStations.length}</th>
                    <th width="50" style={{ textAlign: 'center' }}>100%</th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <LeafletMap geojson={this.selectedBoundaryFeature}
          id='home_map'
          markers={markers}
          center={mapCenter}
          height='55vh'
          onMarkerClick={this.onMarkerClick}
          onMarkerOver={onMarkerOver}
          isLoading={!(!loadingMarkers)}>
          {!!popupUpMarker ? <div
            className='map-info-box'>{this.getPopupBox(popupUpMarker)}</div> : null}
        </LeafletMap>
      </div>
    )

  }
}



// WEBPACK FOOTER //
// ./src/components/Map/IndexLeaflet.js